import clsx from "clsx";
import { ArrowBackSVGIcon } from "components/SVGIcons";
import useDeviceType from "hooks/useDeviceType";
import { ICompany } from "models/HaulPay";
import penniesToDollars from "../../../../../../../helpers/convertPenniesToDollars";
import styles from "./BillToCompanyItem.module.scss";

type BillToCompanyProps = {
  company: ICompany;
  onSelectCompany?: VoidFunction;
};

const STATUS_COLOR_MAP: Record<string, string> = {
  approved: "text-success",
  pending: "text-warning",
  needs_review: "text-warning",
  declined: "text-error",
  declined_3_months: "text-error",
  declined_6_months: "text-error",
  do_not_contact: "text-info"
};

const formatStatus = (status: string) => {
  if (status === "declined_3_months" || status === "declined_6_months") return "Declined";
  if (status === "do_not_contact") return "Do Not Contact";
  return status.replace(/_/g, " ");
};

export default function BillToCompanyItem({ company, onSelectCompany }: BillToCompanyProps) {
  const { isDesktop } = useDeviceType();

  const label = company.dba ?? company.name ?? "Unknown";
  const showCredit = company.credit_approved === "approved";

  return (
    <button type="button" className={clsx(styles.wrapper, "company-btn")} onClick={onSelectCompany}>
      <div className={styles.content}>
        <div className={styles.headerRow}>
          <span className={styles.companyName}>{label}</span>
          {company.credit_approved && (
            <span className={clsx(styles.statusBadge, STATUS_COLOR_MAP[company.credit_approved])}>
              {formatStatus(company.credit_approved)}
            </span>
          )}
        </div>

        {(company.mc || company.dot) && (
          <div className={styles.metaRow}>
            {company.mc && <span>MC# {company.mc}</span>}
            {company.mc && company.dot && <span className={styles.dot}>·</span>}
            {company.dot && <span>DOT# {company.dot}</span>}
          </div>
        )}

        {showCredit && (
          <div className={styles.creditRow}>
            <span className={styles.creditLabel}>Available credit: </span>
            <span className={styles.creditValue}>
              {(() => {
                const credit = Number(company.credit_available);
                return Number.isFinite(credit) ? penniesToDollars(credit) : penniesToDollars(0);
              })()}
            </span>
          </div>
        )}
      </div>

      {!isDesktop && <ArrowBackSVGIcon className={styles.arrow} />}
    </button>
  );
}
